import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "innpact_site_content_v1";

let cache = null;
let subscribers = [];

const emit = (data) => {
  cache = data;
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch { /* storage disabled */ }
  subscribers.forEach((cb) => cb(data));
};

const loadFromStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* storage disabled */ }
  return null;
};

let fetching = false;
const fetchOnce = () => {
  if (fetching) return;
  fetching = true;
  axios
    .get(`${API}/site-content`)
    .then((res) => emit(res.data || {}))
    .catch(() => {})
    .finally(() => { fetching = false; });
};

export const useSiteContent = () => {
  const [data, setData] = useState(cache || loadFromStorage() || {});

  useEffect(() => {
    if (!cache) fetchOnce();
    const cb = (d) => setData(d);
    subscribers.push(cb);
    return () => { subscribers = subscribers.filter((c) => c !== cb); };
  }, []);

  return data;
};

export const refreshSiteContent = fetchOnce;
export default useSiteContent;
